import styled from 'vue-styled-components'

const Wrapper = styled.div`
.list-group-item-action:active {
  background-color: #fff;
}
.button {
  margin-top: 35px;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  /* background: #c8ebfb; */
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}

.sections-draggable {
  margin-top: -1px;
  margin-bottom: -1px;
}

.panel-page-name {
}
.panel-page-content {
  max-height: calc(100% - 44px - 110px);
  overflow-y: scroll;
}

.panel-sticky-button {
  background-color: #FFFFFF;
}
.list-scroll{

}
`;
const PanelItem = styled.div`
    /* position: relative; */
    display: block;
    padding: 6px 16px;
    line-height: 20px;
    background-color: #fff;
    border: 1px solid var(--line);
    border-radius: 4px;
    transition: background-color 0.2s ease-out;
    
    &.hover, &:hover {
      background: var(--fill-focus);
      cursor: pointer;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
      border: 1px solid var(--primary);
      .disabled {
        display: none;
      }
    }
    .panel-tool{
      color: #53585D;
    }

`;
const PanelItemAddSection = styled.div`
    /* position: relative; */
    display: block;
    padding: 6px 16px;
    border: 1px dashed #009CC1;
    color: #009CC1;
    box-sizing: border-box;
    border-radius: 4px;
    transition: border 0.4s ease;
    &.hover, &:hover {
      cursor: pointer;
      /* border: 1px solid #009CC1; */
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
    }

`;
const HorizontalLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e8e8e8;
`;
const PanelSubtitle = styled.span`
  color: #999999;
  font-size: 14px;
`;

export {
  Wrapper,
  HorizontalLine,
  PanelItem,
  PanelSubtitle,
  PanelItemAddSection
}
export default {
  Wrapper,
  HorizontalLine,
  PanelItem,
  PanelSubtitle,
  PanelItemAddSection
}